<template>
<div class="chapter">
<div class="inner_page">
<p class="OT"><a id="page_vi"></a><a id="page_vii">Contents</a></p><a id="page_vii">
</a><p class="TocSb1" id="for"><a id="page_vii"></a><a href="#/xhtml/foreword#for"><i>Foreword</i> by Timothy Keller</a></p>
<p class="Toc2" id="pro"><a href="#/xhtml/prologue#pro">Prologue: Urban Christians</a></p>
<p class="Toc2" id="int"><span href="#/xhtml/introduction#int" title="Link target outside of Sample">Introduction: Stay in the City</span></p>
<p class="Toc1" id="ch-001"><span href="#/xhtml/chapter001#ch001" title="Link target outside of Sample">1.<span class="space">More Is Going On</span></span></p>
<p class="Toc1" id="ch-002"><span href="#/xhtml/chapter002#ch002" title="Link target outside of Sample">2.<span class="space">Whatever You Do</span></span></p>
<p class="Toc1" id="ch-003"><span href="#/xhtml/chapter003#ch003" title="Link target outside of Sample">3.<span class="space">Art and Public Faith</span></span></p>
<p class="Toc1" id="ch-004"><span href="#/xhtml/chapter004#ch004" title="Link target outside of Sample">4.<span class="space">Make Yourselves at Home</span></span></p>
<p class="Toc1" id="ch-005"><span href="#/xhtml/chapter005#ch005" title="Link target outside of Sample">5.<span class="space">The Next Generation</span></span></p>
<p class="Toc1" id="ch-006"><span href="#/xhtml/chapter006#ch006" title="Link target outside of Sample">6.<span class="space">Lessons for the Long Run</span></span></p>
<p class="Toc2" id="epi"><span href="#/xhtml/epilogue#epi" title="Link target outside of Sample">Epilogue: Joy in the City</span></p>
<p class="Toc2" id="aft"><span href="#/xhtml/afterword#aft" title="Link target outside of Sample"><i>Afterword</i> by Peter and Miriam Yvette Acevedo</span></p>
<p class="Toc" id="ack"><span href="#/xhtml/acknowledgements#ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="Toc" id="mor"><span href="#/xhtml/backmatter001#mor" title="Link target outside of Sample">More about City Seminary of New York</span></p>
<p class="Toc" id="not"><span href="#/xhtml/notes#not" title="Link target outside of Sample">Notes</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?27acdb9c